// @ts-nocheck
export const localeCodes =  [
  "de",
  "en"
]
export const localeLoaders = {
  de: [
    {
      key: "locale_de_46js_ce62794e",
      load: () => import("#nuxt-i18n/ce62794e" /* webpackChunkName: "locale_de_46js_ce62794e" */),
      cache: true
    }
  ],
  en: [
    {
      key: "locale_en_46js_9d0b598f",
      load: () => import("#nuxt-i18n/9d0b598f" /* webpackChunkName: "locale_en_46js_9d0b598f" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = []
export const normalizedLocales = [
  {
    code: "de",
    iso: "de-AT",
    name: "Deutsch",
    language: "de-AT"
  },
  {
    code: "en",
    iso: "en-US",
    name: "English",
    language: "en-US"
  }
]
/** client **/

/** client-end **/